export const removeSubstringBetweenPlusAndAt = (email) => {
    const plusIndex = email.indexOf('+');
    const atIndex = email.indexOf('@');
    if (plusIndex !== -1 && atIndex !== -1) {
        const modifiedEmail = email.substring(0, plusIndex) + email.substring(atIndex);
        return modifiedEmail;
    }
    return email; // No plus sign or at sign found, return the original email
}